import { atom } from 'jotai';

import { updateV2SocketData } from '../v2-helper';
import { createTableAccumulatorBunja } from './table-accumulator';

export type Markets = Record<string, SpotMarket> | null;

export interface SpotMarket {
  midPrice: string;
  priceChangePct24h?: string;
  turnover24h?: string;
}

export const spotMarketsAtom = atom<Markets>(null);

export const subscribeSpotMarketsBunja = createTableAccumulatorBunja(
  'market/spots',
  (store) => (wsData) => store.set(spotMarketsAtom, (prev) => updateV2SocketData(prev || {}, wsData)),
);
